<script>
    import { onMount } from 'svelte';
    import { navigate } from 'svelte-routing';
    import ChannelsModal from '../../components/ChannelsModal.svelte';
    import AddressModal from '../../components/common/AddressModal.svelte';
    import Preloader from '../../components/Preloader.svelte';
    import { store, store_offer } from '../../Store.svelte';
    import { CONSTANTS } from '../../components/comparator/utils/constant';
    import OfferMain from './OfferMain.svelte';

    export let toggleEditAddress = () => {};

    let selected = '4p';
    let selectedMovilTerm = 'with-forced-term';
    let selectedMovilMobileData = '5-gb-plan';

    let displayedPlans = { plans: [], category: '' };
    $: selected, setDisplayedPlans(selected);

    function setDisplayedPlans(selected) {
        displayedPlans = getOfferBySelectedPlan(selected);
    }

    function getOfferBySelectedPlan(selected) {
        switch (selected) {
            case '4p':
                return {
                    plans:
                        $store_offer.loadedOffer.offers.izzinegocios_3P ?? [],
                    category: CONSTANTS.CATEGORY_IZZI_NEGOCIOS4P,
                };
            case '3p':
                return {
                    plans:
                        $store_offer.loadedOffer.offers.izzinegocios_3P ?? [],
                    category: CONSTANTS.CATEGORY_IZZI_NEGOCIOS3P,
                };
            case '3pm':
                return {
                    plans: $store_offer.loadedOffer.offers.izzinegocios ?? [],
                    category: CONSTANTS.CATEGORY_IZZI_NEGOCIOS3PM,
                };
            case '2p':
                return {
                    plans: $store_offer.loadedOffer.offers.izzinegocios ?? [],
                    category: CONSTANTS.CATEGORY_IZZI_NEGOCIOS,
                };
            default:
                return {
                    plans: [],
                    category: '',
                };
        }
    }

    onMount(() => {
        $store.requestedServices.isCombo = false;
        if ($store.requestedAddress.offnetCoverage) {
            navigate('/comparador', { replace: true });
        }
        try {
            window.document.dispatchEvent(
                new Event('DOMContentLoaded', {
                    bubbles: true,
                    cancelable: true,
                })
            );
        } catch (err) {}
    });

    $store.requestedServices.isSky = false;

    function onSelectionChange(event) {
        const selectedPlan = mapSelectionToPlan(event);
        onChangePlay({ detail: selectedPlan });
    }

    function mapSelectionToPlan(event) {
        const selectedServices = event.detail;
        const isOffnet = $store.requestedAddress.offnetCoverage;

        if (isOffnet) {
            if (selectedServices.includes('tv')) return 'tv_izzi_offnet';
            if (selectedServices.includes('movil')) return 'movil_offnet';
            return '';
        }

        const serviceMapping = {
            'internet,movil,tv': '4p',
            'internet,movil': '3pm',
            'internet,tv': '3p',
            internet: '2p',
        };

        const key = selectedServices.sort().join(',');
        return serviceMapping[key] || '';
    }

    function onChangePlay(event) {
        selected = event.detail;
    }

    function onChangeMovilTerm(event) {
        selectedMovilTerm = event.target.value;
        selectedMovilMobileData =
            selectedMovilTerm === 'without-forced-term'
                ? '8-gb-plan'
                : '5-gb-plan';
    }

    function onChangeMovilMobileData(event) {
        selectedMovilMobileData = event.target.value;
    }

    function popupClick() {}
</script>

<main>
    {#if $store_offer.loadedOffer == null || $store_offer.loadedOffer.offers == null}
        <div class="pure-g full-width">
            <div class="pure-u-1">
                {#if $store.requestedAddress.postalCode != null && $store.requestedAddress.postalCode.length > 0}
                    <div class="text-center">
                        <h2 class="text-fs-20 fw-semibold base-text m-b-12">
                            obteniendo paquetes
                        </h2>
                        <div
                            class="d-flex align-items-center justify-content-center gap-2 sm-address-buttons"
                        >
                            <p class="text-fs-20 m-b-10">
                                {$store.requestedAddress.addressString},
                                {$store.requestedAddress.postalCode}
                            </p>
                            <p class="text-fs-13 m-b-12 m-t-12">
                                <a
                                    href="#/"
                                    on:click|preventDefault={popupClick}
                                    class="popup base-text underline"
                                    data-custom-open="modal-cobertura"
                                    >cambiar dirección</a
                                >
                            </p>
                        </div>
                    </div>
                {:else}
                    <div class="text-center">
                        <h2 class="text-fs-23 fw-semibold m-b-12 m-t-35">
                            obteniendo paquetes
                        </h2>
                        <div
                            class="d-flex align-items-center justify-content-center gap-2 sm-address-buttons"
                        >
                            <p class="text-fs-20 m-b-0">
                                ingresa tu dirección para validar las ofertas
                                que se encuentran disponibles para tí
                            </p>
                            <p class="text-fs-13 m-b-10 m-t-10">
                                <a
                                    href="#/"
                                    on:click|preventDefault={popupClick}
                                    class="popup base-text underline"
                                    data-custom-open="modal-cobertura"
                                    >ingresar dirección</a
                                >
                            </p>
                        </div>
                    </div>
                {/if}
                <div class="pure-g">
                    <div class="pure-u-1">
                        <div class="text-center">
                            <Preloader
                                status="Obteniendo paquetes disponibles"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {:else}
        <script>
            setTimeout(function () {
                try {
                    window.document.dispatchEvent(
                        new Event('DOMContentLoaded', {
                            bubbles: true,
                            cancelable: true,
                        })
                    );
                } catch (err) {}
            }, 1500);
        </script>
        <div class="pure-g full-width">
            <div class="pure-u-1">
                <OfferMain
                    plansObject={displayedPlans}
                    {onSelectionChange}
                    {toggleEditAddress}
                    {onChangeMovilMobileData}
                    {selectedMovilMobileData}
                    {onChangeMovilTerm}
                    {selectedMovilTerm}
                />
            </div>
        </div>
    {/if}

    <ChannelsModal />

    <div>
        <div class="modal" id="modal-cobertura" aria-hidden="true">
            <AddressModal />
        </div>
    </div>
</main>
